import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Animated, Easing } from 'react-native';
export class AnimatedList extends Component {
    constructor(props) {
        super(props);
        this.animations = {};
        this.listValues = [];
        this.defaultDuration = 300;
    }
    componentDidMount() {
        this.timeout = setTimeout(() => {
            requestAnimationFrame(() => {
                const diff = this.getDiff();
                this.update([...this.props.values], diff);
                this.timeout = undefined;
            });
        });
    }
    shouldComponentUpdate() {
        if (!this.timeout) {
            this.timeout = setTimeout(() => {
                requestAnimationFrame(() => {
                    const diff = this.getDiff();
                    this.update([...this.props.values], diff);
                    this.timeout = undefined;
                });
            });
        }
        return false;
    }
    getDiff() {
        return this.hasDiff(this.listValues.map(value => value[this.props.keyName]), this.props.values.map(value => value[this.props.keyName]));
    }
    hasDiff(prevKeys, nextKeys) {
        const diff = {
            removedKeys: [],
            addedKeys: [],
            hasDiff: false
        };
        diff.removedKeys = prevKeys.filter(key => !nextKeys.includes(key));
        diff.addedKeys = nextKeys.filter(key => !prevKeys.includes(key));
        if (diff.removedKeys.length > 0 || diff.addedKeys.length > 0) {
            diff.hasDiff = true;
        }
        return diff;
    }
    animate(key, toValue, easing) {
        return new Promise(resolve => {
            Animated.timing(this.loadAnimation(key), {
                duration: this.defaultDuration,
                toValue,
                easing,
                useNativeDriver: false
            }).start(value => {
                resolve(value);
            });
        });
    }
    update(values, diff) {
        var _a, _b;
        if (!diff.hasDiff) {
            const result = (_b = (_a = this.props).shouldComponentUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, this.listValues, values);
            if (result === undefined || result) {
                this.listValues = values;
                this.forceUpdate();
            }
            return Promise.resolve(true);
        }
        return Promise.all(diff.removedKeys.map(key => this.animate(key, 0, Easing.in(Easing.ease))))
            .then(() => {
            this.listValues = values;
            this.forceUpdate();
            diff.addedKeys.forEach(key => this.loadAnimation(key));
            return Promise.all(diff.addedKeys.map(key => this.animate(key, 1, Easing.out(Easing.ease))));
        })
            .then(() => {
            const diff = this.getDiff();
            if (diff.hasDiff) {
                return this.update([...this.props.values], diff);
            }
            return true;
        });
    }
    loadAnimation(key) {
        if (!this.animations[key]) {
            this.animations[key] = new Animated.Value(0);
        }
        return this.animations[key];
    }
    render() {
        return (_jsx(Animated.View, { style: Object.assign({ flexDirection: 'row', alignItems: 'center', width: '100%' }, this.props.containerStyle), children: this.listValues.map(value => {
                const key = value[this.props.keyName];
                const animation = this.loadAnimation(key);
                const elementStyle = Object.assign(Object.assign({}, this.props.elementStyle), { transform: [
                        {
                            translateY: animation === null || animation === void 0 ? void 0 : animation.interpolate({
                                inputRange: [0, 1],
                                outputRange: [150, 0]
                            })
                        },
                        { scale: animation }
                    ], opacity: animation });
                return (_jsx(Animated.View, { style: elementStyle, children: this.props.render(value) }, key));
            }) }));
    }
}
